export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10285.a3aca273.jpg";